import type { GapStatusCounts as Counts } from '@/types/api'

interface GapStatusCountsProps {
  counts: Counts | null | undefined
}

/**
 * Page-header counts: open · in progress · resolved. Reads straight off
 * `CurrentGapAnalysisResult.statusCounts`. The mono font + colored values
 * mirror the prototype's status row.
 */
export function GapStatusCounts({ counts }: GapStatusCountsProps) {
  const open = counts?.open ?? 0
  const inProgress = counts?.inProgress ?? 0
  const resolved = counts?.resolved ?? 0

  return (
    <div
      data-testid="gap-status-counts"
      className="flex items-center gap-4 mt-3 font-mono text-xs"
    >
      <span className="text-error">
        <span data-testid="status-open">{open}</span> open
      </span>
      <span className="text-info">
        <span data-testid="status-in-progress">{inProgress}</span> in progress
      </span>
      <span className="text-success">
        <span data-testid="status-resolved">{resolved}</span> resolved
      </span>
    </div>
  )
}
